import React from 'react';

export default function Logo({ collapsed }) {
  return (
    <div style={{
      padding: collapsed ? '12px 8px' : '12px 16px',
      display: 'flex', alignItems: 'center', gap: 10,
      borderBottom: '1px solid rgba(255,255,255,0.07)',
    }}>
      <img
        src="/identium-logo.jpeg"
        alt="Identium"
        style={{
          width: 34, height: 34, borderRadius: 6,
          objectFit: 'cover', flexShrink: 0,
          background: '#fff',
        }}
      />
      {!collapsed && (
        <div>
          <div style={{ color: '#fff', fontWeight: 700, fontSize: 13, lineHeight: 1.2 }}>RFID Delegate</div>
          <div style={{ color: 'rgba(255,255,255,0.45)', fontSize: 10 }}>Identium Tech Solutions</div>
        </div>
      )}
    </div>
  );
}
